import { IconProps } from './icons-props';

function CommentFillIcon({ className, width = 18, height = 18 }: IconProps) {
    return (
        <svg
            fill='none'
            width={width}
            height={height}
            viewBox='0 0 24 24'
            className={className}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='currentColor'
                d='M16 2H8Q2 2 2 8v13c0 .55.45 1 1 1h13q6 0 6-6V8q0-6-6-6m-2 13.25H7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75m3-5H7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75'
            ></path>
        </svg>
    );
}

export default CommentFillIcon;

